import { IAnswer, IOptions, IQuestion } from "../types/types"

export const sortByQuestionList = (list: string[], arr: IQuestion[]) => {
  const tmpMap = arr.reduce(
    (acc: { [key: string]: IQuestion }, item: IQuestion) => {
      acc[item.question_reference] = item
      return acc
    },
    {}
  )

  return list.map((key) => tmpMap[key])
}

export const checkValueIsPresentInAnswer = (
  questionId: number,
  answers: Array<IAnswer> | undefined,
  value: number
) => {
  const _ans = answers?.find((answer) => answer.question_id === questionId)
  if (_ans && Array.isArray(_ans.value)) {
    const idx = _ans.value.indexOf(value)
    return idx > -1
  }
  return false
}

export const determineAllowedConsultationSlots = (
  options: Array<IOptions>,
  consultationSlots: Array<number>
) =>
  consultationSlots && consultationSlots.length
    ? options
        .map((option) =>
          consultationSlots.includes(option.value) ? option : undefined
        )
        .filter((option) => option !== undefined)
    : options
